import { call, put, takeLatest } from 'redux-saga/effects';
import { createAction } from '@reduxjs/toolkit';
import message from '../../utils/message';
import * as api from '../../api';

// Action creators
export const getTestReport = createAction('GET_TEST_REPORT', (payload) => ({ payload }));
export const getTestReportSuccess = createAction('GET_TEST_REPORT_SUCCESS');
export const getTestReportFailure = createAction('GET_TEST_REPORT_FAILURE');

export const createTestReport = createAction('CREATE_TEST_REPORT', (payload) => ({ payload }));
export const createTestReportSuccess = createAction('CREATE_TEST_REPORT_SUCCESS');
export const createTestReportFailure = createAction('CREATE_TEST_REPORT_FAILURE');

export const getUserTestReports = createAction('GET_USER_TEST_REPORTS', (payload) => ({ payload }));
export const getUserTestReportsSuccess = createAction('GET_USER_TEST_REPORTS_SUCCESS');
export const getUserTestReportsFailure = createAction('GET_USER_TEST_REPORTS_FAILURE');

export const getLatestTestReport = createAction('GET_LATEST_TEST_REPORT', (payload) => ({ payload }));
export const getLatestTestReportSuccess = createAction('GET_LATEST_TEST_REPORT_SUCCESS');
export const getLatestTestReportFailure = createAction('GET_LATEST_TEST_REPORT_FAILURE');

// Saga workers
function* getTestReportWorker({ payload }) {
    try {
        const response = yield call(api.getTestReportById, payload.reportId);
        yield put(getTestReportSuccess(response.data));
    } catch (error) {
        console.error('Get test report error:', error);
        yield put(getTestReportFailure(error.message));
        message.error('Failed to fetch test report');
    }
}

function* createTestReportWorker({ payload }) {
    try {
        const response = yield call(api.createTestReport, payload);
        yield put(createTestReportSuccess(response.data));
        message.success('Test report created successfully');
    } catch (error) {
        console.error('Create test report error:', error);
        yield put(createTestReportFailure(error.message));
        message.error('Failed to create test report');
    }
}

function* getUserTestReportsWorker({ payload }) {
    try {
        const { userId, page, limit, testType } = payload;
        const params = { page, limit, testType };
        const response = yield call(api.getTestReports, userId, params);
        yield put(getUserTestReportsSuccess(response.data));
    } catch (error) {
        console.error('Get user test reports error:', error);
        yield put(getUserTestReportsFailure(error.message));
        message.error('Failed to fetch user test reports');
    }
}

function* getLatestTestReportWorker({ payload }) {
    try {
        const { userId, testType } = payload;
        const response = yield call(api.getLatestTestReport, userId, testType);
        yield put(getLatestTestReportSuccess(response.data));
    } catch (error) {
        console.error('Get latest test report error:', error);
        yield put(getLatestTestReportFailure(error.message));
        // Don't show error message for latest report as it might not exist
    }
}

// Saga watchers
export function* testReportSagas() {
    yield takeLatest(getTestReport.type, getTestReportWorker);
    yield takeLatest(createTestReport.type, createTestReportWorker);
    yield takeLatest(getUserTestReports.type, getUserTestReportsWorker);
    yield takeLatest(getLatestTestReport.type, getLatestTestReportWorker);
}